import React, { useState } from 'react';
import { Button, BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import { RiderType } from 'models/rider.model';
import RiderDetailsDashboard from 'components/logistics/rider-detail-dashboard';
import TripHistory from 'components/logistics/trip-history';
import SelectBrand from 'components/base/select-brand';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
const RiderDetailsSideModal = ({
  show,
  onClose,
  rider
}: {
  show: boolean;
  onClose: () => void;
  rider: RiderType;
}) => {
  const [selectedBrandIds, setSelectedBrandIds] = useState(rider.brand_ids);
  const [disabled, setDisabled] = useState(true);
  const sendDetails = async () => {
    try {
      await apiService.put(`logistics/admin/update-user/${rider.id}`, {
        data: { brand_ids: selectedBrandIds.filter((item) => item !== '') },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Edited rider successfully' />);
      onClose();
      setDisabled(true);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    }
  };

  return (
    <BaseModal
      position='right'
      isOpen={show}
      onRequestClose={onClose}
      title=''
      titleIconColor='gray'
      size='wide'>
      <div className='space-y-8'>
        <RiderDetailsDashboard rider={rider} />
        <div className='flex justify-end'>
          <SelectBrand
            label='Select brand(s) rider should be added to'
            defaultValue={selectedBrandIds}
            setBrands={(e) => {
              setSelectedBrandIds(e);
              setDisabled(false);
            }}
          />
        </div>
        <TripHistory riderId={rider.id} partnerId={rider.logistics_company_id ?? ''} />
        <div className='flex justify-center'>
          <Button
            disabled={disabled}
            onClick={sendDetails}
            small
            className='my-14 w-full '
            color='primary'
            variant='block'>
            Update delivery brands
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default RiderDetailsSideModal;
